/* MP Motion — ports the V3 mockup animation layer into the live theme.
   1) Scroll reveals  2) Cursor tilt on SKU cards  3) Hero gummy rain with simple physics + cursor shove. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. Scroll reveals ---- */
  var revealSel = '.mp-sku-rail__head, .mp-sku-card, .mp-manifesto__stack > *, .mp-apparel-film__head, .mp-apparel-film__cell, .mp-gear__card, .mp-locator-cta .page-width > *';
  if (!reduced) {
    var targets = document.querySelectorAll(revealSel);
    targets.forEach(function (el, i) {
      el.classList.add('mp-reveal');
      el.style.transitionDelay = (i % 6) * 55 + 'ms';
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mp-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '-30px' });
      targets.forEach(function (el) { io.observe(el); });
    } else {
      targets.forEach(function (el) { el.classList.add('mp-in'); });
    }
  }

  /* ---- 2. Cursor tilt on SKU cards ---- */
  if (!reduced && window.matchMedia('(hover: hover)').matches) {
    document.querySelectorAll('.mp-sku-card').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var rx = ((e.clientY - r.top) / r.height - 0.5) * -7;
        var ry = ((e.clientX - r.left) / r.width - 0.5) * 9;
        card.style.transform = 'perspective(800px) translateY(-8px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg)';
      });
      card.addEventListener('mouseleave', function () { card.style.transform = ''; });
    });
  }

  /* ---- 3. Hero chew drift ----
     This used to be a one-shot physics rain: chews fell, bounced on a floor 22px off the
     bottom, then set settled=true and stopped for good. Within about four seconds the hero
     held a static row of candy along the bottom edge, piled under the CTAs, and on touch
     devices (no cursor to shove them awake) it stayed that way for the whole visit.
     Now they drift, tumble and recycle off the top, so the hero never goes static and
     nothing collects at the bottom. The cursor shove is kept, as an impulse that decays. */
  var hero = document.querySelector('.mp-video-hero');
  if (!hero || reduced || !window.MP_GUMMIES) return;
  var layer = document.createElement('div');
  layer.style.cssText = 'position:absolute;inset:0;overflow:hidden;z-index:4;pointer-events:none';
  hero.appendChild(layer);
  var W = hero.clientWidth, H = hero.clientHeight;
  var chews = [];

  function seed(g, above) {
    /* the copy column is left aligned and capped at 660px, so keep the drift to the right
       of it on desktop and let it spread on narrow screens where the copy stacks */
    var lead = W < 750 ? 0.06 : 0.40;
    g.x  = W * lead + Math.random() * Math.max(W * (1 - lead) - g.s, 40);
    g.y  = above ? -g.s - Math.random() * H * 0.75 : Math.random() * (H - g.s);
    g.vy = 0.30 + Math.random() * 0.42;      /* constant fall, no gravity, so it never speeds into a pile */
    g.vx = (Math.random() - 0.5) * 0.22;
    g.vr = (Math.random() - 0.5) * 1.1;
  }

  var count = W < 750 ? 6 : 10;
  for (var i = 0; i < count; i++) {
    var img = document.createElement('img');
    img.src = window.MP_GUMMIES[i % window.MP_GUMMIES.length];
    img.alt = '';
    var size = 28 + Math.random() * 32;
    img.style.cssText = 'position:absolute;left:0;top:0;width:' + size + 'px;opacity:.82;' +
      'will-change:transform;filter:drop-shadow(0 10px 14px rgba(0,0,0,.5))';
    layer.appendChild(img);
    var g = { el: img, s: size, r: Math.random() * 360 };
    seed(g, false);
    chews.push(g);
  }

  var mouse = { x: -9999, y: -9999 };
  if (window.matchMedia('(hover: hover)').matches) {
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      mouse.x = e.clientX - r.left; mouse.y = e.clientY - r.top;
    });
    hero.addEventListener('mouseleave', function () { mouse.x = -9999; mouse.y = -9999; });
  }

  function tick() {
    W = hero.clientWidth; H = hero.clientHeight;
    for (var i = 0; i < chews.length; i++) {
      var g = chews[i];
      var cx = g.x + g.s / 2, cy = g.y + g.s / 2;
      var dx = cx - mouse.x, dy = cy - mouse.y, d2 = dx * dx + dy * dy;
      if (d2 < 16000) {                       /* cursor shove, decays back to the drift */
        var d = Math.sqrt(d2) || 1;
        g.vx += (dx / d) * 1.5;
        g.vy += (dy / d) * 1.0;
        g.vr += (Math.random() - 0.5) * 6;
      }
      g.vx *= 0.94;                            /* bleed the shove off */
      g.vr *= 0.97;
      g.vy += (0.42 - g.vy) * 0.04;            /* ease back to the base fall speed */
      g.x += g.vx; g.y += g.vy; g.r += g.vr;

      if (g.y > H + g.s) seed(g, true);        /* recycle off the top, never settle */
      if (g.x < -g.s - 30) g.x = W + 10;
      if (g.x > W + 30) g.x = -g.s - 10;
      g.el.style.transform = 'translate(' + g.x.toFixed(1) + 'px,' + g.y.toFixed(1) + 'px) rotate(' + g.r.toFixed(1) + 'deg)';
    }
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
})();

/* ---- 4. Alley light (MP's own world: streetlight drift + fresh-tag glow) ----
   The brick wall itself is a fixed CSS layer; this canvas only paints LIGHT on it,
   screen-blended so it lifts the dark and never touches type. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var TAGS = [[143,228,2],[255,215,21],[255,61,110],[139,92,246],[41,182,246],[255,138,42]];
  var cv = document.createElement('canvas');
  cv.id = 'mp-alley-light';
  cv.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;z-index:1;pointer-events:none;' +
    'mix-blend-mode:screen;opacity:.85';
  document.body.appendChild(cv);
  var ctx = cv.getContext('2d'), W = 0, H = 0, t = 0, last = 0, flick = 1, blooms = [];

  function size(){ W = cv.width = window.innerWidth; H = cv.height = window.innerHeight; }
  function bloom(){
    var c = TAGS[(Math.random() * TAGS.length) | 0];
    blooms.push({ x: Math.random() * W, y: Math.random() * H, c: c, life: 0,
                  max: 260 + Math.random() * 420, r: 90 + Math.random() * 190 });
  }
  function draw(now){
    requestAnimationFrame(draw);
    if (now - last < 50) return;                       /* 20fps is plenty for light */
    last = now; t += 0.006;

    ctx.clearRect(0, 0, W, H);

    /* the security light: a warm pool that drifts and breathes */
    var lx = W * (0.5 + Math.sin(t * 0.42) * 0.30);
    var ly = H * (0.34 + Math.cos(t * 0.31) * 0.18);
    if (Math.random() < 0.012) flick = 0.55 + Math.random() * 0.3;   /* rare failing-bulb blink */
    flick += (1 - flick) * 0.10;
    var R = Math.max(W, H) * 0.62;
    var g = ctx.createRadialGradient(lx, ly, 0, lx, ly, R);
    g.addColorStop(0,   'rgba(255,176,84,' + (0.13 * flick).toFixed(3) + ')');
    g.addColorStop(0.42,'rgba(190,120,60,' + (0.055 * flick).toFixed(3) + ')');
    g.addColorStop(1,   'rgba(0,0,0,0)');
    ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);

    /* cool bounce from the far end of the alley */
    var bx = W * (0.5 - Math.sin(t * 0.27) * 0.34), by = H * 0.78;
    var g2 = ctx.createRadialGradient(bx, by, 0, bx, by, R * 0.7);
    g2.addColorStop(0, 'rgba(60,120,190,0.055)');
    g2.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = g2; ctx.fillRect(0, 0, W, H);

    /* fresh tags catching the light, then fading back into the wall */
    if (blooms.length < 4 && Math.random() < 0.05) bloom();
    for (var i = blooms.length - 1; i >= 0; i--) {
      var b = blooms[i]; b.life++;
      var p = b.life / b.max;
      if (p >= 1) { blooms.splice(i, 1); continue; }
      var a = Math.sin(p * Math.PI) * 0.14;
      var gb = ctx.createRadialGradient(b.x, b.y, 0, b.x, b.y, b.r * (0.6 + p * 0.7));
      gb.addColorStop(0, 'rgba(' + b.c[0] + ',' + b.c[1] + ',' + b.c[2] + ',' + a.toFixed(3) + ')');
      gb.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = gb; ctx.fillRect(0, 0, W, H);
    }
  }
  size();
  var rt; window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(size, 200); });
  requestAnimationFrame(draw);
})();
